var _defs, _path, _path2, _path3, _rect, _rect2, _path4, _path5, _path6, _path7, _path8, _path9, _rect3, _rect4, _path10, _path11, _path12, _rect5, _rect6, _rect7, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 509.23 364.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 225,
    y1: 279.58,
    x2: 246.68,
    y2: 279.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5c6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#ead4d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0e9cb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 196.9,
    y1: 214.27,
    x2: 270.4,
    y2: 214.27,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 235.47,
    y1: 403.52,
    x2: 245.47,
    y2: 302.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 236.71,
    y1: 341.09,
    x2: 236.71,
    y2: 400.36,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 224.9,
    y1: 346.73,
    x2: 252.31,
    y2: 206.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 210.88,
    y1: 311.27,
    x2: 250.61,
    y2: 311.27,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 223.84,
    y1: 324.62,
    x2: 258.66,
    y2: 324.62,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 170.56,
    y1: 395.25,
    x2: 224.36,
    y2: 395.25,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 259.78,
    y1: 395.21,
    x2: 306.81,
    y2: 395.21,
    xlinkHref: "#a"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M47.72 209.34c5.86-11.1 15.44-21.13 15.81-33.68.26-9.18-4.56-17.6-8.09-26.09-18-43.23.64-98.39 41.13-121.9 22.1-12.83 48.29-16.49 73.8-17.93a500.35 500.35 0 0186.79 2.63c16.88 2 34.55 5.23 47.61 16.1 20.47 17 23.36 46.63 31.14 72.09 13.67 44.72 47.42 82.87 90.13 101.9 7.73 3.44 15.92 6.4 22.17 12.1 13.71 12.48 13.85 34.94 5.4 51.44s-23.52 28.43-38.17 39.83l-45.46 35.45c-9.2 7.17-18.62 14.47-29.65 18.26-36.75 12.64-86.6-2.22-124.75-3.91-24.63-1.1-50.74 1.34-74.81-5.08-53.28-14.23-124.33-81.88-93.05-141.21z",
    fill: "#4b39ef",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.83,
    y: 187.67,
    width: 136.11,
    height: 83.47,
    rx: 10.6,
    transform: "rotate(-180 338.605 204.39)",
    fill: "#4b39ef",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.79,
    y: 227.5,
    width: 105.11,
    height: 65.32,
    rx: 8.24,
    transform: "rotate(-180 123.06 235.14)",
    fill: "#4b39ef",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.81 165.57h-160a26.46 26.46 0 01-26.43-26.42V26.53A26.46 26.46 0 01322.81.1h160a26.46 26.46 0 0126.42 26.43v112.62a26.45 26.45 0 01-26.42 26.42zm-160-161.52a22.5 22.5 0 00-22.48 22.48v112.62a22.5 22.5 0 0022.48 22.47h160a22.5 22.5 0 0022.47-22.47V26.53a22.5 22.5 0 00-22.47-22.48zM200.05 73.42h-64.9a11.9 11.9 0 01-11.89-11.89V15.86a11.9 11.9 0 0111.89-11.9h64.9a11.9 11.9 0 0111.89 11.9v45.67a11.9 11.9 0 01-11.89 11.89zm-64.9-65.46a8 8 0 00-7.94 7.94v45.67a8 8 0 007.94 7.94h64.9a8 8 0 007.94-7.94V15.86a8 8 0 00-7.94-7.9z",
    fill: "#4b39ef",
    opacity: 0.63,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M225.82 292.41a6.15 6.15 0 001 3.21 4.57 4.57 0 002.14 1.39c3.82 1.35 8-.21 11.75-1.76a10.11 10.11 0 004.36-2.77 9.44 9.44 0 001.47-5.29 79.24 79.24 0 00-.93-18.07 9.62 9.62 0 00-1.53-4.39c-1.85-2.45-5.33-2.78-8.4-2.9-7.73-.29-10-1.28-10.44 6.82a147.34 147.34 0 00.58 23.76z",
    transform: "translate(-2.56 -50.04)",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M203.56 234.62a41 41 0 007.62 11.63 32.35 32.35 0 0049.6-3.51c4.8-6.69 6.86-14.94 8.3-23.05 1.25-7.1 2.1-14.49.25-21.46-2.43-9.11-9.4-16.62-17.8-20.88s-18.1-5.5-27.5-4.83c-5.88.43-11.82 1.62-16.93 4.54-10.1 5.74-10.56 13.7-10.1 24.08.55 11.38 1.83 22.99 6.56 33.48z",
    transform: "translate(-2.56 -50.04)",
    fill: "url(#d)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M222.9 97.08c-2.78-3-6.07-6.06-10.17-6.55s-8.78 2.9-8 7c-6.35-3.05-13.79-5.56-20.29-2.85-5.46 2.26-9 8-9.76 13.82s1 11.82 3.76 17a28.37 28.37 0 006.13 8.1c5.86 5.16 14 6.6 21.78 7.51 13.2 1.54 26.84 2.1 39.49-2 3.82-1.23 8.59-2.67 11.37.23 2.07 2.15 2.69 6.41 5.68 6.4 2.42 0 3.52-3 3.75-5.43a44.83 44.83 0 00-1.72-17.12c-2.91-9.63-9.84-17-20.39-16.92-9.77.12-14.88-1.81-21.63-9.19z",
    fill: "#e08142"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 199.58,
    y: 149.95,
    width: 25.75,
    height: 17.78,
    rx: 7.23,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3.95
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 234.6,
    y: 149.95,
    width: 25.75,
    height: 17.78,
    rx: 7.23,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3.95
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M223.07 156.99h14.35v2.13h-14.35zm-33.49-2.22h11.67v3.33h-11.67zm69.27 1.3h12.97v2.22h-12.97z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M197.07 185.74a40.73 40.73 0 00.66 9.62c1.62 7 7 12.79 13.38 16.08a51.41 51.41 0 015.55 2.92c1.82 1.25 3.33 2.93 5.16 4.18a14.17 14.17 0 0014.94.45c1.39-.83 2.77-1.95 4.39-1.87 1.24 0 2.32.81 3.49 1.21 2.67.91 5.59-.08 8.15-1.27s4.93-2.61 6-5.05c.71-1.58.74-3.37 1.08-5.07.86-4.36 3.67-8.06 5.4-12.16 3.6-8.49 2.4-18.16 1.14-27.29l-4.16 6.89c-1.4 2.32-3 4.79-5.54 5.71-3.35 1.19-6.91-.75-10.15-2.24a42.21 42.21 0 00-32.68-.85c-2.16.86-4.45 1.92-6.72 1.38-2.7-.64-6.65-7.74-8.78-7.12-2.6.78-1.29 12.3-1.31 14.48z",
    fill: "#e08142"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M223.3 233.22c27.08-3.86 55.85 9.87 69.89 33.35 4.68 7.84 7.82 16.57 13 24.1 5.47 8 13 14.29 19.29 21.63a87.06 87.06 0 0112.65 19.59c3 6.44 5.13 14.48 1.1 20.35-3.7 5.4-11 6.7-17.55 7.19-13 1-26.11.67-39.17.34l-128.32-3.17c-5.72-.14-11.58-.31-16.89-2.44s-10-6.69-10.68-12.37c-1-8.32 6.45-14.84 12-21.13 16.13-18.36 19.74-45.07 35.28-63.93a63.48 63.48 0 0147.54-22.77",
    fill: "#4b39ef"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M225.86 283.26c27.08-3.86 55.85 9.87 69.89 33.35 4.68 7.84 7.82 16.57 13 24.1 5.47 8 13 14.29 19.29 21.63a87.06 87.06 0 0112.65 19.59c3 6.44 5.13 14.48 1.1 20.35-3.7 5.4-11 6.7-17.55 7.19-13 1-26.11.67-39.17.34l-128.32-3.17c-5.72-.14-11.58-.31-16.89-2.44s-10-6.69-10.68-12.37c-1-8.32 6.45-14.84 12-21.13 16.13-18.36 19.74-45.07 35.28-63.93A63.48 63.48 0 01224 284",
    transform: "translate(-2.56 -50.04)",
    fill: "url(#b)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#4b39ef",
    d: "M178.65 350.18h116.13v7.78H178.65z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M178.65 350.18h116.13v7.78H178.65z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 146.6,
    y: 221.64,
    width: 182.66,
    height: 110.39,
    rx: 20.61,
    fill: "#4b39ef"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 146.6,
    y: 224.97,
    width: 182.66,
    height: 110.39,
    rx: 20.61,
    fill: "url(#c)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    fill: "url(#f)",
    d: "M210.88 330.71l19.44-39.43h17.79l2.5 39.99-39.73-.56z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#4b39ef",
    d: "M257 357.96h-34.83l8.15-66.68h17.79l8.89 66.68z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M258.66 357.96h-34.82l8.15-66.68h17.78l8.89 66.68z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 298.33,
    width: 208.93,
    height: 161.51,
    rx: 24.45,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M124.69 200.25H18.23A18.26 18.26 0 010 182.01V107.1a18.26 18.26 0 0118.23-18.24h106.46a18.26 18.26 0 0118.23 18.24v74.91a18.26 18.26 0 01-18.23 18.24zM18.23 92.81A14.31 14.31 0 003.94 107.1v74.91a14.31 14.31 0 0014.29 14.29h106.46a14.31 14.31 0 0014.29-14.29V107.1a14.31 14.31 0 00-14.29-14.29z",
    fill: "#4b39ef",
    opacity: 0.63,
    style: {
      isolation: "isolate"
    }
  }), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1.97,
    y: 88.16,
    width: 138.98,
    height: 107.44,
    rx: 16.26,
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 124.96,
    y: 4.14,
    width: 84.73,
    height: 65.5,
    rx: 9.91,
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M135.76 37.58l21.38-11v3.18l-18 9v.1l18 9v3.19l-21.38-11zm24.36 15.38l12.86-33.42h3.13l-12.9 33.42zm40.26-12.76l-21.36 11v-3.24l18.15-9v-.15l-18.15-9v-3.24l21.36 11z",
    fill: "#4b39ef"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M212.62 385.73c-4.58-.92-9.3-.08-14 .06-4.48.13-9-.4-13.43 0s-9.07 2-11.93 5.41a11.85 11.85 0 00-2.72 7.93 6.21 6.21 0 00.8 3.08c1.22 1.95 3.76 2.54 6 2.87a4.06 4.06 0 001.39 0c1.65-.36 2.23-2.48 3.66-3.36a5.64 5.64 0 013.13-.54q17.58.36 35.17-.14a4.63 4.63 0 002.33-.48c3.2-2-.5-6.48-1.65-8.62a12.66 12.66 0 00-8.75-6.21z",
    transform: "translate(-2.56 -50.04)",
    fill: "url(#h)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M261.4 391.74c-1.61 2.21-2.49 5.72-.32 7.38 1.95 1.5 4.81.26 6.63-1.39s3.48-3.79 5.9-4.26c.36 2.1.84 4.4 2.56 5.65 2.61 1.9 6.21.26 9.43.29 2.9 0 6.21 1.37 8.45-.48 1.16-1 2.48-2.77 3.68-1.85a2.39 2.39 0 01.69 1.23 34.38 34.38 0 004.8 9.45c1.46.57 2.56-1.41 2.84-3a47.44 47.44 0 00.51-13.14c-.24-2.44-.76-5-2.5-6.76-2.27-2.27-5.86-2.37-9.07-2.32l-12.88.19c-7.66.15-15.95 2.49-20.72 9.01z",
    transform: "translate(-2.56 -50.04)",
    fill: "url(#i)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M251.99 261.53a12.77 12.77 0 11-12.79-12.79 8.57 8.57 0 012 .2 12.61 12.61 0 0010.74 12.12 1.83 1.83 0 01.05.47z",
    fill: "#4b39ef",
    opacity: 0.59,
    style: {
      isolation: "isolate"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M324.96 21.4h53.4v3.92h-53.4zm0 7.58h32.59v3.68h-32.59zm45.74 0h102.56v3.7H370.7zm-28.79 7.59h44.82v3.88h-44.82zm14.39 7.58h53.4v3.92h-53.4zm56.88 0h44.76v4.35h-44.76zm-56.96 7.58h41.23v3.68h-41.23zm45.19 0h85.08v4.07h-85.08zm-76.45 10.25h53.4v3.92h-53.4zm0 7.58h32.59v3.68h-32.59zm45.74 0h102.56v3.7H370.7zm-28.79 7.58h44.82v3.88h-44.82zm14.39 7.59h53.4v3.92h-53.4zm56.88 0h44.76v4.35h-44.76zm-56.96 7.58h41.23v3.68h-41.23zm45.19 0h85.08v4.07h-85.08zm-76.45 10.26h53.4v3.92h-53.4zm0 7.57h32.59v3.68h-32.59zm45.74 0h102.56v3.7H370.7zm-28.79 7.58h44.82v3.88h-44.82zm14.39 7.58h53.4v3.92h-53.4zm56.88 0h44.76v4.35h-44.76zm-56.96 7.6h41.23v3.68h-41.23zm45.19 0h85.08v4.07h-85.08zm-382.9-27.97H53.2v2.54H18.51zm0 4.92h21.18v2.39H18.51zm29.72 0h66.63v2.4H48.23zm-18.71 4.94h29.12v2.52H29.52zm9.35 4.92h34.69v2.54H38.87zm36.95 0h29.08v2.83H75.82zm-37 4.93h26.79v2.39H38.82zm29.35 0h55.28v2.65H68.17zm-49.66 6.66H53.2v2.54H18.51zm0 4.92h21.18v2.39H18.51zm29.72 0h66.63v2.4H48.23zm-18.71 4.93h29.12v2.52H29.52zm9.35 4.93h34.69v2.54H38.87zm36.95 0h29.08v2.83H75.82zm-37 4.92h26.79v2.39H38.82zm29.35 0h55.28v2.65H68.17zm-49.66 6.67H53.2v2.54H18.51zm0 4.92h21.18v2.39H18.51zm29.72 0h66.63v2.4H48.23zm-18.71 4.92h29.12v2.52H29.52zm9.35 4.93h34.69v2.54H38.87zm36.95 0h29.08v2.83H75.82zm-37 4.93h26.79v2.39H38.82zm29.35 0h55.28v2.65H68.17z",
    opacity: 0.52,
    fill: "#4b39ef"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M338.05 250.67c.32-1.71.66-3.42 1-5.13.18-1 .35-1.93.54-3 1.6.27 3.16.52 4.71.82a.8.8 0 001.05-.52c.7-1.36 1.48-2.68 2.3-4a.77.77 0 00-.07-1.12c-1-1.19-2-2.42-3.11-3.69l6.7-5.63c1 1.23 2.06 2.42 3.05 3.65a.84.84 0 001.22.28 33.56 33.56 0 014.14-1.51c.65-.19.8-.45.79-1.06v-4.65h8.74v4.67c0 .62.16.85.79 1a35.33 35.33 0 014.14 1.52.83.83 0 001.21-.3c1-1.21 2-2.39 3.05-3.64l6.69 5.62-3.43 4.11c.93 1.71 1.8 3.35 2.73 4.95.1.18.54.27.8.23 1.56-.24 3.12-.53 4.78-.82l1.52 8.6c-1.63.29-3.21.56-4.78.87-.26.05-.64.29-.68.5-.31 1.82-.56 3.65-.85 5.58l4.62 2.68-4.37 7.57-4.65-2.67c-1.5 1.2-2.95 2.34-4.38 3.53a.83.83 0 00-.13.74c.52 1.55 1.09 3.08 1.67 4.68l-8.21 3c-.51-1.39-1.06-2.75-1.49-4.15a1.19 1.19 0 00-1.5-1 31.73 31.73 0 01-4.25 0 .71.71 0 00-.87.58c-.52 1.5-1.08 3-1.66 4.56l-8.22-3 1.84-5.08-4.63-3.9-4.69 2.7-4.38-7.57c1.45-.84 2.81-1.64 4.19-2.41a.76.76 0 00.43-1 44.39 44.39 0 01-.76-4.27c-.09-.7-.25-1-1-1.13-1.52-.17-3-.5-4.52-.77zm26.76-10.43a11.17 11.17 0 1011 11.36 11.23 11.23 0 00-11-11.36zm48.72 35.72l1.91 6c-1.11.37-2.18.69-3.21 1.08a.91.91 0 00-.51.65c-.09 1.06-.06 2.12-.14 3.18a.7.7 0 00.53.85c1 .37 2 .81 3.08 1.25-.8 2-1.56 3.85-2.35 5.79-1.09-.44-2.12-.89-3.17-1.26a.91.91 0 00-.8.18c-.84.89-1.63 1.84-2.51 2.85l1.79 3.42-5.52 2.94c-.55-1-1.05-2-1.6-3a.88.88 0 00-.66-.4c-1.27.15-2.54.38-3.85.58l-.83 3.77-6.1-1.31.79-3.77c-1.13-.74-2.21-1.47-3.32-2.15a.79.79 0 00-.7.12c-.9.66-1.77 1.36-2.71 2.09l-3.85-4.93c.92-.72 1.76-1.4 2.63-2.05a.67.67 0 00.3-.94 27.5 27.5 0 01-1-2.95.68.68 0 00-.78-.62h-3.16v-6.3h3.94c.5-1.18 1-2.36 1.51-3.57.07-.18-.12-.55-.29-.72-.78-.76-1.61-1.47-2.47-2.25l4.18-4.65 2.88 2.57c1.22-.62 2.41-1.2 3.58-1.84.14-.08.2-.46.18-.68-.12-1.08-.29-2.16-.45-3.33l6.19-.86c.16 1.11.32 2.13.43 3.16.06.58.3.82.91.89a19.56 19.56 0 012.71.59.77.77 0 001.06-.39c.53-.93 1.12-1.81 1.74-2.79l5.29 3.32-2 3.27c.79 1.07 1.56 2.13 2.37 3.14a1 1 0 00.77.12c1.06-.31 2.12-.66 3.21-1.05zm-16.8 16.75a8 8 0 10-8.12-7.84 8 8 0 008.12 7.87zm18.19-50.61l2.41-1.89 3.06 3.87c-.59.47-1.11 1-1.7 1.34s-.81.81-.41 1.46a2.94 2.94 0 01.3.76c.52 1.58.52 1.58 2.22 1.65h1.21v4.89h-2.55c-.47 0-.7.11-.8.57a6.05 6.05 0 01-.36 1.09c-.62 1.55-.63 1.55.65 2.68l1 .87-3.28 3.69-2.3-2c-.9.47-1.8.91-2.67 1.41a.82.82 0 00-.25.65c.08.84.22 1.67.34 2.58l-4.87.71c-.13-.89-.23-1.73-.41-2.54a.93.93 0 00-.56-.6c-.9-.23-1.81-.38-2.82-.58l-1.63 2.6-4.19-2.59c.45-.74.86-1.45 1.31-2.13a.63.63 0 00-.08-1 8.61 8.61 0 01-.95-1.13c-.77-1.07-.76-1.07-2.05-.65-.51.18-1 .34-1.66.54l-1.55-4.67c.81-.27 1.56-.55 2.34-.77a.72.72 0 00.61-.87 13.67 13.67 0 01.08-2.12.69.69 0 00-.53-.85c-.77-.27-1.52-.59-2.33-.92l1.82-4.58c.84.33 1.62.67 2.42.93a.87.87 0 00.75-.16c.66-.69 1.26-1.43 1.93-2.2l-1.42-2.7 4.33-2.34 1.48 2.69 3.36-.5.64-3 4.82 1c-.17.84-.32 1.63-.5 2.42a.73.73 0 00.43 1c.79.38 1.54.89 2.36 1.39zm-14 9.24a6.28 6.28 0 106.39-6.26 6.22 6.22 0 00-6.38 6.26z",
    opacity: 0.61,
    fill: "#4b39ef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoding);
export default __webpack_public_path__ + "static/media/coding.1d4bc796350a063087f73898dda3a82f.svg";
export { ForwardRef as ReactComponent };